
export const baseURL = "https://app.burstyai.com";
const ENVCONFIG = ""


// agent
export const AGENT_FETCH = `${ENVCONFIG}/burstyai/aiagents`; // 创建agent
export const GET_AGENT_FETCH = `${ENVCONFIG}/burstyai/aiagents/system`; // 获取所有agent
export const MOVE_AGENT_TO_SYSTEM_FETCH = `${ENVCONFIG}/burstyai/aiagents/admin/move`; // move_agent_to_system
export const MOVEOUT_AGENT_TO_SYSTEM_FETCH = `${ENVCONFIG}/burstyai/aiagents/admin/moveout`; // moveout_agent_from_system
export const COPY_AGENT_TO_SYSTEM_FETCH = (id, agentName) => `${ENVCONFIG}/burstyai/aiagents/${id}/duplicate?agentName=${agentName}`; // duplicate_agent
export const STRIPE_AGENT_CHECKOUT = `${ENVCONFIG}/ssosrv/stripe/checkout`; // 订阅 agent
export const SUBSCRIPTION_PUST_AGENT = (id) => `${ENVCONFIG}/burstyai/aiagents/subscription/${id}/assign`; // 分配订阅
export const GET_AGENT_KNOWLEDGE_IDS = (id) => `${ENVCONFIG}/burstyai/aiagents/${id}/knowledge`; // 查询这个订阅的agent的knowledge IDs

// 
export const GET_AGENT_HISTORY = `${ENVCONFIG}/burstyai/aiagents/conversation`; // get agent history
export const GET_AGENT_CONVERSATION = (projectId, agentId) => `${ENVCONFIG}/burstyai/aiagents/conversation?projectId=${projectId}&agentId=${agentId}`; // get a converation
export const SENT_AGENT = `${ENVCONFIG}/chatbot/`; // 
export const GET_ALL_CONVERSATIONS = (projectId, agentId) => `${ENVCONFIG}/burstyai/aiagents/allconversations?projectId=${projectId}&agentId=${agentId}`; // 
export const DELETE_CONVERSATIONS = `${ENVCONFIG}/burstyai/aiagents/conversation`; // 删除 conversation
export const UPDATE_CONVERSATIONS = (id, name) => `${ENVCONFIG}/burstyai/aiagents/conversation/${id}?name=${name}`; // 更新 conversation
export const REFRESH_AGENT_UNREAD_NUMBER = `${ENVCONFIG}/burstyai/aiagents/refreshagents`; //   用来获取某个项目的所有分配agent的总的未读消息数量

export const GET_AGENT_CONVERSATION_PUBLIC = (publicUUID) => `${ENVCONFIG}/burstyai/aiagents/${publicUUID}/conversation`; // create_a_converation(public)
export const GET_AGENT_INFO_DETAIL = (id, isPublicUUD) => `${ENVCONFIG}/burstyai/aiagents/public/${id}?isPublicUUD=${isPublicUUD}`; // 获取 agent信息 支持免登录
export const GET_UNREAD_INFO_DETAIL = (id) => `${ENVCONFIG}/burstyai/aiagents/conversation/${id}/unread`; // 更新

export const BOT_CONFIG_SETTING =(agentId)=> `${ENVCONFIG}/burstyai/aiagents/${agentId}/botconfigsv2`; // 
export const POST_LEADS_WITHOUT_LOGIN = `${ENVCONFIG}/burstyai/chatbotleads/public`; //
export const POST_CUSTOM_FORM_WITHOUT_LOGIN = `${ENVCONFIG}/burstyai/sheet/custom/form/row`; //
